// 
// Ecommlab Milestone Bar in cart drawer
// - displays animated bar showing how much more the customer needs to spend to recieve free shipping at checkout
// 
window.theme = window.theme || {};

theme.MilestoneBar = (function() {

  function MilestoneBar(container) {
    this.container = container;

    if(!container){
      return;
    }

    this.sectionId = this.container.id;

    this.bindElements();
    this.bindEvents();

  }

  MilestoneBar.prototype = {

    parseThemeData: function(){
      const themeDataContainer = document.querySelector(`[data-section="${this.sectionId}"]`)
      if (!themeDataContainer){
        console.log('error: Unable to load settings for marquee section')
        return;
      }

      const themeData = JSON.parse(themeDataContainer.innerHTML);
      if (!themeData){
        console.log('Error: Unable to find theme data');
        return;
      }
      return themeData;
    },

    bindElements: function(){
      const self = this;
      
      self.thresholdContainer = document.getElementById('milestone-bar-threshold');
      self.success = self.container.querySelector('.milestone-bar__title.milestone-bar__title--success');
      self.progress = self.container.querySelector('.milestone-bar__title.milestone-bar__title--progress');
      self.milestoneBar = self.container.querySelector('.milestone-bar__progress');

    },

    bindEvents: async function(){
      const self = this;
      
      self.onPageLoad();

      document.addEventListener('ajaxProduct:added', function(event) {
        self.onPageLoad();
      });
  
      document.addEventListener('cart:updated', function(event){
        self.handleCartUpdate(event.detail.cart);
      });

    },

    handleCartUpdate: async function(cart){
      const self = this;

      self.cart = cart;

      let threshold = parseInt(self.data.threshold_amount);
      let difference = threshold - cart.total_price;
      let money_left = theme.Currency.formatMoney(difference); 

      if (difference <= 0 ){
        self.success.classList.remove('hide');
        self.progress.classList.add('hide');
        self.milestoneBar.style.transform = `translate(0,0)`;
      }
      else {
        self.success.classList.add('hide');
        self.success.innerHTML = (''+self.data.success_message+'').replace('[amount]',`<strong>${money_left}</strong>`);
        
        self.progress.classList.remove('hide');
        self.progress.innerHTML = (''+self.data.progress_message+'').replace('[amount]', `<strong>${money_left}</strong>`);
        let position = (difference / threshold) * 100;
        self.milestoneBar.style.transform = `translate(-${Math.abs(position)}%,0)`;
      }

    },

    onPageLoad: async function(){
      const self = this;

      self.data = JSON.parse(self.thresholdContainer.innerText);
      let cart = await self.getCart();
      self.handleCartUpdate(cart);
    },

    getCart: async function(){
      const self = this;

      return new Promise(function(resolve, reject) {

        fetch('/cart.js')
        .then(res => res.text())
        .then(html => {
          if (html){
            resolve(JSON.parse(html));
          } 
        })
        .catch(error => {
          console.log(error);
          resolve();
        })
      });
    }

  }

  return MilestoneBar;

})();

document.addEventListener('DOMContentLoaded', function() {
  const MilestoneBarContainer = document.querySelector('.milestone-bar');
  if (MilestoneBarContainer){
    new theme.MilestoneBar(MilestoneBarContainer);
  }
});
